@if (facade.row(); as r) {
<div class="order-details">
  <div class="info-row">
    <span class="info-label">{{
      'admin.storageRequests.orderFullIdLabel' | translate
    }}</span>
    <div class="info-value-with-copy">
      <span class="info-value info-value--mono">{{ r.id }}</span>
      <button
        type="button"
        class="copy-action"
        (click)="facade.copyToClipboard(r.id)"
        [attr.aria-label]="'common.copy' | translate"
      >
        <img
          class="copy-action__icon"
          src="/icons/core/copy.svg"
          alt=""
          width="16"
          height="16"
        />
      </button>
    </div>
  </div>

  <div class="info-row">
    <span class="info-label">{{ 'admin.storageRequests.source' | translate }}</span>
    <span class="info-value">{{ facade.sourceLabelKey(r.source) | translate }}</span>
  </div>

  <div class="info-row">
    <span class="info-label">{{
      'admin.storageRequests.orderTypeLabel' | translate
    }}</span>
    <span class="info-value">{{ facade.orderTypeLabel(r) | translate }}</span>
  </div>

  @if (r.user_id) {
  <div class="info-row">
    <span class="info-label">{{ 'admin.storageRequests.userId' | translate }}</span>
    <div class="info-value-with-copy">
      <span class="info-value info-value--mono">{{ r.user_id }}</span>
      <button
        type="button"
        class="copy-action"
        (click)="facade.copyToClipboard(r.user_id!)"
        [attr.aria-label]="'common.copy' | translate"
      >
        <img
          class="copy-action__icon"
          src="/icons/core/copy.svg"
          alt=""
          width="16"
          height="16"
        />
      </button>
    </div>
  </div>
  }

  @if (r.first_name?.trim()) {
  <div class="info-row">
    <span class="info-label">{{ 'admin.storageRequests.firstName' | translate }}</span>
    <span class="info-value">{{ r.first_name }}</span>
  </div>
  }

  <div class="info-row">
    <span class="info-label">{{ 'admin.storageRequests.phone' | translate }}</span>
    <div class="info-value-with-copy">
      <a class="info-value info-value--link" [href]="'tel:' + r.phone">{{
        facade.formatPhone(r.phone)
      }}</a>
      <button
        type="button"
        class="copy-action"
        (click)="facade.copyToClipboard(r.phone)"
        [attr.aria-label]="'common.copy' | translate"
      >
        <img
          class="copy-action__icon"
          src="/icons/core/copy.svg"
          alt=""
          width="16"
          height="16"
        />
      </button>
    </div>
  </div>

  @if (r.address_id) {
  <div class="info-row">
    <span class="info-label">{{
      'admin.storageRequests.addressIdLabel' | translate
    }}</span>
    <div class="info-value-with-copy">
      <span class="info-value info-value--mono">{{ r.address_id }}</span>
      <button
        type="button"
        class="copy-action"
        (click)="facade.copyToClipboard(r.address_id!)"
        [attr.aria-label]="'common.copy' | translate"
      >
        <img
          class="copy-action__icon"
          src="/icons/core/copy.svg"
          alt=""
          width="16"
          height="16"
        />
      </button>
    </div>
  </div>
  }

  @if (r.delivery_address_id) {
  <div class="info-row">
    <span class="info-label">{{
      'admin.storageRequests.deliveryAddressIdLabel' | translate
    }}</span>
    <div class="info-value-with-copy">
      <span class="info-value info-value--mono">{{ r.delivery_address_id }}</span>
      <button
        type="button"
        class="copy-action"
        (click)="facade.copyToClipboard(r.delivery_address_id!)"
        [attr.aria-label]="'common.copy' | translate"
      >
        <img
          class="copy-action__icon"
          src="/icons/core/copy.svg"
          alt=""
          width="16"
          height="16"
        />
      </button>
    </div>
  </div>
  }

  <div class="info-row">
    <span class="info-label">{{
      'admin.storageRequests.createdAtLabel' | translate
    }}</span>
    <span class="info-value">{{ r.created_at | date:'dd.MM.yyyy, HH:mm' }}</span>
  </div>

  <div class="info-row">
    <span class="info-label">{{
      'admin.storageRequests.updatedAtLabel' | translate
    }}</span>
    <span class="info-value">{{ r.updated_at | date:'dd.MM.yyyy, HH:mm' }}</span>
  </div>

  @if (r.completed_at) {
  <div class="info-row">
    <span class="info-label">{{
      'admin.storageRequests.completedAtLabel' | translate
    }}</span>
    <span class="info-value">{{ r.completed_at | date:'dd.MM.yyyy, HH:mm' }}</span>
  </div>
  }
</div>
}
